import { Link } from "react-router-dom";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryGrid from "@/pages/home/components/CategoryGrid";
import SectionHeading from "@/components/feature/SectionHeading";
import MediaCard from "@/components/base/MediaCard";
import { getHotMedia, getNewMedia } from "@/utils/media";

const highlights = [
  {
    icon: "ri-database-2-line",
    title: "海量影视资源",
    desc: "覆盖电影、电视剧、综艺、动漫等多个板块，分类清晰，随时浏览。",
  },
  {
    icon: "ri-filter-3-line",
    title: "多条件智能筛选",
    desc: "按地区、年份、评分区间复合筛选，几秒钟定位你想看的作品。",
  },
  {
    icon: "ri-heart-3-line",
    title: "一键收藏追剧",
    desc: "无需登录即可收藏喜欢的影视，保存在浏览器本地，随时回看。",
  },
  {
    icon: "ri-device-line",
    title: "多端流畅体验",
    desc: "电脑与手机自适应布局，卡片式浏览，碎片时间也能轻松看片。",
  },
];

export default function Home() {
  const hot = getHotMedia(10);
  const fresh = getNewMedia(10);

  return (
    <div className="w-full">
      <HeroCarousel />

      <div className="mx-auto w-full px-4 md:px-6">
        <section className="py-10 md:py-14">
          <SectionHeading icon="ri-apps-2-line" title="影视分类快捷入口" desc="选择感兴趣的分类，快速进入对应片库" />
          <CategoryGrid />
        </section>

        <section className="border-t border-background-200 py-10 md:py-14">
          <SectionHeading
            icon="ri-fire-line"
            title="热门影视推荐"
            desc="按播放热度排序，大家都在看"
            moreTo="/category/movie"
          />
          <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-5">
            {hot.map((item) => (
              <MediaCard key={item.id} media={item} />
            ))}
          </div>
        </section>

        <section className="border-t border-background-200 py-10 md:py-14">
          <SectionHeading
            icon="ri-time-line"
            title="最新上架"
            desc="刚刚入驻片库的新鲜影视作品"
            moreTo="/search"
            moreLabel="浏览全部"
          />
          <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-5">
            {fresh.map((item) => (
              <MediaCard key={item.id} media={item} />
            ))}
          </div>
        </section>
      </div>

      <section className="bg-primary-50 py-12 md:py-16">
        <div className="mx-auto w-full px-4 md:px-6">
          <SectionHeading icon="ri-award-line" title="为什么选择 91 免费影视" desc="专注内容与体验的影视浏览平台" />
          <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
            {highlights.map((item) => (
              <div
                key={item.title}
                className="rounded-lg bg-background-50 p-5 ring-1 ring-primary-100 transition duration-300 hover:-translate-y-1 hover:ring-primary-300"
              >
                <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-accent-100 text-xl text-accent-700">
                  <i className={item.icon} />
                </span>
                <h3 className="mt-4 font-heading text-base font-bold text-foreground-900">{item.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="mx-auto w-full px-4 py-12 md:px-6 md:py-16">
        <div className="relative overflow-hidden rounded-xl bg-primary-800">
          <div className="absolute inset-0 opacity-30">
            <img
              src="https://readdy.ai/api/search-image?query=Abstract%20cinematic%20background%20of%20a%20dark%20blue%20movie%20theater%20with%20soft%20rows%20of%20glowing%20seats%20and%20a%20large%20bright%20screen%20glow%2C%20deep%20navy%20and%20cyan%20tones%2C%20moody%20lighting%2C%20high%20detail%2C%20no%20text&width=1600&height=600&seq=cta-91-01&orientation=landscape"
              alt="影视平台观看场景示意"
              className="h-full w-full object-cover"
            />
          </div>
          <div className="relative px-6 py-12 text-center md:px-16 md:py-16">
            <h2 className="font-heading text-2xl font-bold text-background-50 md:text-4xl">
              找到你的下一部心头好
            </h2>
            <p className="mx-auto mt-4 max-w-2xl text-sm leading-relaxed text-background-200 md:text-base">
              从热门大片到口碑剧集，从热血动漫到轻松综艺，91 免费影视为你聚合值得一看的内容。输入关键词，或从分类开始探索。
            </p>
            <div className="mt-7 flex flex-wrap items-center justify-center gap-3">
              <Link
                to="/search"
                className="flex items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-6 py-3 text-sm font-bold text-primary-950 transition-colors hover:bg-accent-400"
              >
                <i className="ri-search-line text-lg" />
                搜索影视作品
              </Link>
              <Link
                to="/category/movie"
                className="flex items-center gap-2 whitespace-nowrap rounded-md border border-background-100/40 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-background-50/10"
              >
                <i className="ri-film-line text-lg" />
                浏览电影频道
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}